export type WakeupLevelPoint = { date: string; level: number }
export type WakeupData = { levels: WakeupLevelPoint[] }
export const WAKEUP_LABELS: Record<number, string> = {
  0: 'Low Priority',
  1: 'Among top 10 issues',
  2: 'Top 3 issue',
  3: 'Top urgent issue',
  4: 'Emergency response',
  5: 'Wartime level',
}

export const WAKEUP_DATES = [
  '2026-01-01',
  '2027-01-01',
  '2028-01-01',
  '2029-01-01',
  '2030-01-01',
  '2031-01-01',
  '2032-01-01',
  '2033-01-01',
  '2034-01-01',
  '2035-01-01',
  '2036-01-01',
  '2037-01-01',
  '2038-01-01',
  '2039-01-01',
  '2040-01-01',
  '2041-01-01'
] as const

export const makeLevels = (values: number[]): WakeupLevelPoint[] => {
  return WAKEUP_DATES.map((date, i) => ({ date, level: values[i] ?? 0 }))
}

export const getWakeupLevelFromLevels = (levels: WakeupLevelPoint[], targetDate: Date): number => {
  const targetTime = targetDate.getTime()
  let closestLevel = 0
  for (const { date, level } of levels) {
    const levelTime = new Date(date).getTime()
    if (levelTime <= targetTime) {
      closestLevel = level
    } else {
      break
    }
  }
  return closestLevel
}
